import React from 'react';
import styled from 'styled-components';
import PageLayout from '../components/layout/PageLayout';
import UserList from '../components/admin/UserList';

const AdminPage = () => {
  return (
    <PageLayout>
      <Container>
        <UserList />
      </Container>
    </PageLayout>
  );
};

const Container = styled.div`
  padding: 1rem 0;
`;

export default AdminPage;
